import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 20;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;
                this.thaitext(
                    pdf,
                    "รายงานสรุปจำนวนผู้เรียนแยกตามโรงเรียน",
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endLarge);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                this.thaitext(
                    pdf,
                    "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ผู้พิมพ์ข้อมูล : " + ' ' + (this.currentProfile ? this.currentProfile.fullName : '-'),
                    pdf_width - 40,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                let hasEnrollDate = this.courseEnrollDate.start ? true : false;
                let startDate = this.moment(this.courseEnrollDate.start).format("YYYY-MM-DD");
                let endDate = this.moment(this.courseEnrollDate.end).format("YYYY-MM-DD");
                this.thaitext(
                    pdf,
                    "ข้อมูลวันที่ : " + (hasEnrollDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "สถาบัน : " + this.instituteName,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "วิชา : " + (this.selectedSubjectText || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ชื่อคอร์ส : " + (this.selectedCourse?.courseName || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                const tableHeader = ["ชื่อโรงเรียน", "ระดับชั้นเรียน", "จำนวนผู้เรียน\n(คน)"];
                const colWidths = [255, 55, 55];
                let headerX = 40;
                pdf.setLineWidth(0.1);
                pdf.setFont("Sarabun", "bold");

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                const lineSpacing = 5; // Extra padding between multiline texts

                const renderTableHeader = () => {
                    cellHeight = 25
                    pdf.setFont("Sarabun", "bold");

                    for (let i = 0; i < tableHeader.length; i++) {
                        const width = colWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableHeader[i].split('\n');
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                        let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;

                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 20
                }

                // Create table header
                renderTableHeader();

                pdf.setFont("Sarabun", "normal");
                cellHeight = 20
                let finalRowHeight;

                const maxPrintableY = pdf_height - margin_b;

                if (this.studentCountBySchoolList.length > 0) {
                    this.studentCountBySchoolList.forEach((row) => {
                        let columnX = margin_l;
                        const schoolName = row.education ? 'โรงเรียน' + row.education : '-';
                        const gradeLevel = row.gradeLevel ? row.gradeLevel.toString() : '-';

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const schoolNameLines = pdf.splitTextToSize(schoolName, colWidths[0] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 5;
                        const calculatedSchoolNameHeight = (schoolNameLines.length * fontHeight) + ((schoolNameLines.length - 1) * lineSpacing) + 10;

                        finalRowHeight = Math.max(cellHeight, calculatedSchoolNameHeight);

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            headerX = margin_l;
                            renderTableHeader();
                        }
                        // ==========================================

                        // --- DRAW COLUMN 1: School Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                        const totalSchoolNameHeight = (schoolNameLines.length * fontHeight) + ((schoolNameLines.length - 1) * lineSpacing);
                        let nameY = pdf_position_y + (finalRowHeight - totalSchoolNameHeight) / 2 + fontHeight;
                        schoolNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, nameY);
                            nameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[0];

                        // --- DRAW COLUMN 2: Grade Level ---
                        pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                        this.thaitext(pdf, gradeLevel, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[1];

                        // --- DRAW COLUMN 3: Student Count ---
                        pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                        const enrollCountText = (row.enrollCount).toString();
                        const enrollCountWidth = pdf.getStringUnitWidth(enrollCountText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                        this.thaitext(pdf, (row.enrollCount).toString(), columnX + (colWidths[2] - enrollCountWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[2];

                        // 4. Move Y down cleanly by the shared unified row height
                        pdf_position_y += finalRowHeight;
                    });

                    // ==========================================
                    // DRAW THE TOTAL SUMMARY ROW
                    // ==========================================

                    // 1. Calculate total sum dynamically from your list
                    const totalCourses = this.studentCountBySchoolList.reduce((sum, row) => sum + (Number(row.enrollCount) || 0), 0);

                    // 2. Check if there is enough space on the current page for the summary row
                    if (pdf_position_y + finalRowHeight > maxPrintableY) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset to top if it overflows
                    }

                    // 3. Set the font style to Bold for the summary row
                    pdf.setFont("Sarabun", "bold");

                    let currentX = margin_l;

                    // Combine widths of Column 1, 2 for the text "รวมทั้งหมด"
                    const spanWidth = colWidths[0] + colWidths[1];

                    // Draw the rectangle background for the spanned section (optional grey background like the image)
                    pdf.setFillColor(240, 240, 240); // Light grey color
                    pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'F'); // Fill background
                    pdf.rect(currentX, pdf_position_y, spanWidth, finalRowHeight, 'S'); // Draw border stroke

                    // Calculate text width for right alignment with a small padding (e.g., 15 units from the right edge)
                    const labelText = "รวมทั้งหมด";
                    const labelWidth = pdf.getStringUnitWidth(labelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    const labelX = currentX + spanWidth - labelWidth - 15;
                    const labelY = pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight;

                    // Render "รวมทั้งหมด"
                    this.thaitext(pdf, labelText, labelX, labelY);

                    // Move currentX to the 4th column (Course Count)
                    currentX += spanWidth;

                    // 4. Draw Column 4: Total sum number box
                    pdf.setFillColor(240, 240, 240);
                    pdf.rect(currentX, pdf_position_y, colWidths[2], finalRowHeight, 'F');
                    pdf.rect(currentX, pdf_position_y, colWidths[2], finalRowHeight, 'S');

                    const totalText = totalCourses.toString();
                    const totalWidth = pdf.getStringUnitWidth(totalText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    // Center align the total number in the last column
                    const totalX = currentX + (colWidths[2] - totalWidth) / 2;

                    this.thaitext(pdf, totalText, totalX, labelY);

                    pdf_position_y += finalRowHeight;
                } else {
                    let currentX = margin_l;
                    cellHeight = 25;

                    // Combine widths of Column 1, 2 for the text "รวมทั้งหมด"
                    const spanWidth = colWidths[0] + colWidths[1] + colWidths[2];

                    pdf.setFillColor(240, 240, 240);
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'F');
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'S');

                    const labelText = 'ไม่มีข้อมูล';
                    const totalWidth = pdf.getStringUnitWidth(labelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    // Center align the total number in the last column
                    const totalX = currentX + (spanWidth - totalWidth) / 2;
                    const labelY = pdf_position_y + (cellHeight - fontHeight) / 2 + fontHeight;

                    this.thaitext(pdf, labelText, totalX, labelY);
                }

                setTimeout(() => {
                    pdf.save("รายงานสรุปจำนวนผู้เรียนแยกตามโรงเรียน.pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}